module.exports = __webpack_public_path__ + "img/packing.c657789c.png";